import ApiService from "../utils/ApiService";
import { validatePhoneNumber } from "../utils/Common";

export const validateUserAddDataForSuperAdmin = (params) => {
  const errors = [];

  if (!params.name) {
    errors.push('User full name is required');
  }

  if (!params.restaurantId) {
    errors.push('Branch name is required');
  }

  if (!params.role) {
    errors.push('Address is required');
  }

  if (!params.phone) {
    errors.push('Phone is required.');
  }

  if (!validatePhoneNumber(params.phone)) {
    errors.push('Phone number is not valid.');
  }
  
  return errors;
};

export function validateUserEditDataForSuperAdmin({
  restaurantId,
  role,
}) {
  const errors = [];

  if (!restaurantId) {
    errors.push("Restaurant selection is required.");
  }

  if (!role) {
    errors.push("Role selection is required.");
  }

  return errors;
}


export const getParentRestaurantDropdown = async(filter = {}, token = '') => {
  const response = await ApiService.GET_RESTAURANT_DROPDOWN(filter, token);
  
  if (response.code !== 200) {
    return [];
  }

  return response.payload.records.map(item => {
    const parentItem = {
      value: item.id,
      label: item.name,
      branches: item.branches.map(brItem => ({value: brItem.id, label: brItem.name}))
    };
    return parentItem;
  });
}

export const updateProfileSettings = async(user, restaurantId, paymentOptions, acceptPayAfterEat, vatInfo) => {
  const params = {
    restaurantId,
    paymentOptions,
    acceptPayAfterEat: acceptPayAfterEat ? "YES" : "NO",
    bin: vatInfo.bin,
    vatRegNo: vatInfo.vatRegNo,
    mushak: vatInfo.mushak
  };

  const res = await ApiService.UPDATE_PAYMENT_METHOD(params, user.token.token);

  return res;
}

export const getBranchIdOnMissedDefaultBranchId = (defaultBranchId, restaurants) => {
  if (defaultBranchId) {
    return defaultBranchId;
  }

  if (restaurants && restaurants.length > 0) {
    return restaurants[0].branches[0].restaurantId;
  }

  return "";
}
